import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import PopupTitle from './popup_title';

const StaleAppVersionModal = ({ onReload }) => {
  return (
    <Dialog
      open
      maxWidth="xs"
      fullWidth
      onClose={() => {}}
      PaperProps={{
        style: {
          width: '260px',
          height: 'initial',
          maxHeight: 'initial',
          padding: '8px 16px',
        },
      }}>
      <PopupTitle
        titleText={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ display: 'flex', margin: 'auto' }}>
              <WarningIcon
                style={{
                  color: 'orange',
                }}
              />
              <div style={{ margin: 'auto 0' }}>App update available</div>
            </div>
          </div>
        }
      />
      <div style={{ marginTop: '24px' }}>
        There is a new version of the app available. Please reload to get the
        latest updates.
      </div>
      <Button
        variant="contained"
        color="primary"
        style={{ margin: '24px 6px 6px' }}
        onClick={onReload}>
        Reload
      </Button>
    </Dialog>
  );
};

StaleAppVersionModal.propTypes = {
  onReload: PropTypes.func.isRequired,
};

export default StaleAppVersionModal;
